import React, { memo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ButtonV2 } from 'src/components/general/button/lgg-button';
import { Icon } from 'src/components/general/icon';
import { FlexColumn } from 'src/components/layout/flex-column';
import { FlexRow } from 'src/components/layout/flex-row';
import { ContactInteractionInputManagerContext } from 'src/components/pages/conversations/components/contact-interactions/contact-interactions-input-area/contact-interaction-input-manager';
import {
  ContactInteractionsReplyModeInfoMessage,
  ContactInteractionsReplyModeInfoMessageBody,
  ContactInteractionsReplyModeInfoMessageTitle,
} from 'src/components/pages/conversations/components/contact-interactions/contact-interactions-input-area/contact-interactions-reply-mode-message';
import { useConversationTakeover } from 'src/components/pages/conversations/hooks/use-conversation-takeover';

const TakeoverButton = styled(ButtonV2)`
  align-self: flex-start;
`;

const MessageIcon = styled(Icon)`
  margin-right: 10px;

  svg {
    width: 18px;
    height: 18px;

    path {
      fill: ${({ theme }) => theme.colors.topaz};
    }
  }
`;

export const useHasActiveAiAgent = () => {
  const { activeAiAgent } = useContext(ContactInteractionInputManagerContext);

  return !!activeAiAgent;
};

export const ActiveAiAgentBanner = memo(() => {
  const { t } = useTranslation(['conversations']);
  const { activeAiAgent, contact, conversationId } = useContext(
    ContactInteractionInputManagerContext,
  );
  const { takeover, isTakingOver } = useConversationTakeover();

  if (!activeAiAgent || !conversationId) {
    return null;
  }

  return (
    <ContactInteractionsReplyModeInfoMessage
      lggId="ai-agent-in-charge-info-message"
      iconOverride={<MessageIcon type="ivrSpeaker" />}
      body={
        <FlexRow style={{ gap: '10px', justifyContent: 'space-between' }}>
          <FlexColumn>
            <ContactInteractionsReplyModeInfoMessageTitle>
              {t(
                'conversations:messageInput.modes.reply.messages.aiAgent.isActive.title',
                {
                  name: activeAiAgent.friendlyName || activeAiAgent.name,
                },
              )}
            </ContactInteractionsReplyModeInfoMessageTitle>
            <ContactInteractionsReplyModeInfoMessageBody>
              {t('conversations:messageInput.modes.reply.messages.aiAgent.isActive.body')}
            </ContactInteractionsReplyModeInfoMessageBody>
          </FlexColumn>
          <TakeoverButton
            size="small"
            variant="primary"
            disabled={isTakingOver}
            onClick={() => void takeover({ contactId: contact.id })}
            data-lgg-id="ai-agent-takeover-button"
          >
            {t(
              'conversations:messageInput.modes.reply.messages.aiAgent.isActive.takeover',
            )}
          </TakeoverButton>
        </FlexRow>
      }
    />
  );
});
